export function sanitizeRedirectPath(redirect: unknown, fallback = '/'): string {
  if (typeof redirect !== 'string') return fallback
  const candidate = redirect.trim()
  if (!candidate.startsWith('/')) return fallback
  if (candidate.startsWith('//')) return fallback
  if (/[\r\n]/.test(candidate)) return fallback
  return candidate
}
